import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { EszkozLayoutComponent } from './eszkoz-layout/eszkoz-layout.component';
import { EszkozokComponent } from './eszkozok/eszkozok.component';
import { MegterulesComponent } from './megterules/megterules.component';
import { ProfilMenuComponent } from '../components/profil-menu/profil-menu.component';
import { SzerkZarSavComponent } from '../components/szerk-zar/szerk-zar-sav.component';

// TÁRGYI ESZKÖZ (ESZKOZ) – önálló alrendszer; a NAPLO ügyféltörzsével és kettős könyvelésével
// dolgozik (backend: kettos-eszkoz.js, /api/eszkoz). A routing az app-routing.module-ban.
@NgModule({
  declarations: [EszkozLayoutComponent, EszkozokComponent, MegterulesComponent],
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ProfilMenuComponent, SzerkZarSavComponent],
  exports: [EszkozLayoutComponent, EszkozokComponent, MegterulesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EszkozModule {}
